import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { dashboardStudentsData } from "../../../ApiService/ApiService";
import { BarChart, PieChart } from "@mui/x-charts";

function Students({ schoolId, sessions, sessionsError, sessionsLoading }) {
  const [sessionId, setSessionId] = useState("");
  const [studentData, setStudentData] = useState(null);
  const [pieData, setPieData] = useState([]);
  const [barData, setBarData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (sessionId) {
      setLoading(true);
      setError(null);
      dashboardStudentsData(sessionId, schoolId)
        .then((response) => {
          const data = response.data.data;
          setStudentData(data);
          setPieData([
            {
              id: 0,
              value: data.boysCount,
              label: "Male Students",
              color: "green",
            },
            {
              id: 1,
              value: data.girlsCount,
              label: "Female Students",
            },
            {
              id: 2,
              value: data.otherCount,
              label: "Other Students",
              color: "orange",
            },
          ]);
          const grades = data.byGrade;
          setBarData({
            xAxis: grades.map((grade) => grade.name),
            series: [
              {
                label: "Boys",
                data: grades.map((grade) => grade.boys),
                color: "green",
              },
              {
                label: "Girls",
                data: grades.map((grade) => grade.girls),
              },
              {
                label: "Others",
                data: grades.map((grade) => grade.others),
                color: "orange",
              },
            ],
          });
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching student data:", error);
          setError("Error fetching student data");
          setLoading(false);
          setStudentData(null);
        });
    }
  }, [sessionId, schoolId]);

  useEffect(() => {
    if (sessions?.data?.length > 0) {
      setSessionId(sessions.data[0].id);
    }
  }, [sessions]);

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <FormControl required size="small" sx={{ width: "30%", marginBottom: 2 }}>
        <InputLabel id="sessions">Sessions</InputLabel>
        <Select
          name="sessionId"
          label="Sessions"
          labelId="sessions"
          value={sessionId}
          onChange={(e) => setSessionId(e.target.value)}
          size="small"
          disabled={sessionsLoading || sessionsError}
        >
          {sessionsLoading ? (
            <MenuItem value="">
              <CircularProgress size={24} />
            </MenuItem>
          ) : sessionsError ? (
            <MenuItem value="">
              <Alert severity="error">Error fetching sessions</Alert>
            </MenuItem>
          ) : (
            sessions?.data?.map((currSession) => (
              <MenuItem key={currSession.id} value={currSession.id}>
                {currSession.name}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress size={48} />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : studentData ? (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ marginBottom: 1, fontWeight: "bold" }}
              >
                Students Pie Chart
              </Typography>
              <PieChart series={[{ data: pieData }]} width={500} height={250} />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ marginBottom: 1, fontWeight: "bold" }}
              >
                Students by Grade
              </Typography>
              <BarChart
                xAxis={[{ scaleType: "band", data: barData.xAxis }]}
                series={barData.series}
                width={600}
                height={300}
              />
            </Box>
          </Box>
        </>
      ) : (
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          Please select a session to view student data.
        </Typography>
      )}
    </Box>
  );
}

export default Students;
